import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaRegCircleXmark } from "react-icons/fa6";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAllAds, updateAd } from "../../store/slices/apiAdsSlice";
import { closeModal } from "../../store/slices/editModalSlice";
import Select from "react-select";

const EditModalAds = ({ id, isOpen }) => {
  const dispatch = useDispatch();
  const adsData = useSelector((state) => state.apiAds.data);
  const categoryOptions = useSelector((state) => state.apiCategory.data);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [showId, setShowId] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [schoolIsActive, setSchoolIsActive] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const adToEdit = adsData?.data?.find((ad) => ad.id === id);
      if (adToEdit) {
        setTitle(adToEdit.title);
        setDescription(adToEdit.description);
        setShowId(adToEdit.categoryName);
        setSchoolIsActive(adToEdit.status === 1);
        setImage(adToEdit.image);
      }
    }
  }, [adsData, id, isOpen]);

  const handleUpdate = (e) => {
    e.preventDefault();

    const selectedCategoryId = selectedOption ? selectedOption.value : null;

    const updatedAd = {
      id,
      title,
      description,
      status: schoolIsActive ? 1 : 0,
      category_id: selectedCategoryId,
      image,
    };

    dispatch(updateAd(updatedAd))
      .unwrap()
      .then(() => {
        toast.success("Reklama u përditësua me sukses!");
        dispatch(getAllAds());
        dispatch(closeModal());
      })
      .catch(() => {
        toast.error("Ndodhi një gabim gjatë përditësimit.");
      });
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  const handleOptionChange = (selectedOptions) => {
    setSelectedOption(selectedOptions);
  };

  const handleSchoolStatusChange = (isChecked) => {
    setSchoolIsActive(isChecked);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="update-ad-title"
    >
      <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>

      <div className="relative bg-white rounded-lg shadow-lg w-[360px] mx-4">
        <button
          type="button"
          onClick={handleCancel}
          aria-label="Close modal"
          className="absolute top-3 right-3 text-gray-400 hover:bg-gray-200 rounded-full w-8 h-8 flex justify-center items-center focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <FaRegCircleXmark size={20} />
        </button>

        <div className="p-6 text-center">
          <h3
            id="update-ad-title"
            className="mb-5 text-xl font-semibold text-gray-700"
          >
            Përditëso Reklamën
          </h3>

          <form className="space-y-4 text-start" onSubmit={handleUpdate}>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Titulli"
              required
            />

            <textarea
              rows="3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Përshkrimi"
              required
            />

            <div>
              <label
                htmlFor="input2"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Lloji i kategorisë:
                <div className="text-gray-400 font-normal">
                  Kategoria e zgjedhur aktuale: <br />
                  <span className="text-red-400 font-light">{showId}</span>
                </div>
              </label>
              <Select
                isClearable
                name="input2"
                id="input2"
                value={selectedOption}
                onChange={handleOptionChange}
                options={categoryOptions.map((option) => ({
                  value: option.id,
                  label: option.name,
                }))}
                className="text-sm"
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Statusi Autoshkolles:
              </label>
              <div className="flex flex-wrap gap-2">
                <button
                  type="button"
                  className={`text-sm rounded-lg px-3 py-1 ${
                    schoolIsActive
                      ? "bg-green-500 text-white"
                      : "bg-gray-200 text-gray-700"
                  }`}
                  onClick={() => handleSchoolStatusChange(true)}
                >
                  Aktiv
                </button>
                <button
                  type="button"
                  className={`text-sm rounded-lg px-3 py-1 ${
                    !schoolIsActive
                      ? "bg-red-500 text-white"
                      : "bg-gray-200 text-gray-700"
                  }`}
                  onClick={() => handleSchoolStatusChange(false)}
                >
                  Pasiv
                </button>
              </div>
            </div>

            {image && (
              <div className="mb-2">
                <img
                  src={`https://back2.autoshkollaime.com/${image}`}
                  alt="Preview"
                  className="w-full max-h-48 object-contain rounded border"
                />
              </div>
            )}

            <div className="flex justify-center gap-2">
              <button
                type="submit"
                className="text-white bg-blue-500 hover:bg-blue-600 rounded-lg text-sm font-medium px-5 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Përditëso
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="text-gray-700 bg-white hover:bg-gray-100 border border-gray-300 rounded-lg text-sm font-medium px-5 py-2.5 focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                Anulo
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditModalAds;
